/* @flow */
import * as React from 'react';
import URI from 'urijs';

import Image from 'components/Image.jsx';
import Text from 'components/Text.jsx';
import Link from 'components/Link.jsx';
import Row from 'components/Row.jsx';
import openUrl from 'utils/openUrl';

import './styles/MessageItemLinkPreview.scss';

type Props = {
  linkPreview: *,
};

class MessageItemLinkPreview extends React.Component<Props, *> {
  getHostForUrl(url: string) {
    return URI(url).hostname() || URI(`http://${url}`).hostname();
  }

  render() {
    const { linkPreview } = this.props;
    return (
      <div className="MessageItemLinkPreview">
        {linkPreview.imageUrl && (
          <Link
            className="MessageItemLinkPreview-thumbnail"
            onClick={() => openUrl(linkPreview.url)}>
            <Image className="MessageItemLinkPreview-thumbnail-image" src={linkPreview.imageUrl} />
          </Link>
        )}
        <div className="MessageItemLinkPreview-text">
          <Row size="xsmall">
            <Link onClick={() => openUrl(linkPreview.url)}>
              <Text
                className="MessageItemLinkPreview-text-title"
                size="xsmall"
                truncate
                weight="semibold"
                wrap={false}
                color="brand"
                align="left">
                {linkPreview.title || linkPreview.url}
              </Text>
            </Link>
            {linkPreview.title &&
              linkPreview.description && (
                <Text color="eclipse" size="xxxsmall" truncate wrap={false}>
                  {linkPreview.description}
                </Text>
              )}
          </Row>
          <Text color="koala" size="xxxxxsmall">
            {this.getHostForUrl(linkPreview.url)}
          </Text>
        </div>
      </div>
    );
  }
}

export default MessageItemLinkPreview;
